import React, { useState, useEffect } from 'react';
import image1 from '../asets/Ad.jpg'; // Ensure the correct path
import image2 from '../asets/SPORTS2.jpg';
import image3 from '../asets/SPORTS3.jpg';
import './Center.css'; // Import the CSS file
import Features from './Features';

function Center() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex === 2 ? 0 : prevIndex + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div id="carouselExampleCaptions" className="carousel">
      <div className="carousel-inner">
        {/* Slide 1 */}
        <div className={`carousel-item ${activeIndex === 0 ? 'active' : ''}`}>
          <div className="slide-container">
            <img src={image1} alt="Slide 1" className="carousel-image" />
            
          </div>
        </div>

        {/* Slide 2 */}
        <div className={`carousel-item ${activeIndex === 1 ? 'active' : ''}`}>
          <div className="slide-container">
            <img src={image2} alt="Slide 2" className="carousel-image" />
            
          </div>
        </div>

        {/* Slide 3 */}
        <div className={`carousel-item ${activeIndex === 2 ? 'active' : ''}`}>
          <div className="slide-container">
            <img src={image3} alt="Slide 3" className="carousel-image" />
            
          </div>
        </div>
      </div>

    <Features/>
    </div>
  );
}

export default Center;
